import { PipeTransform, Pipe } from "@angular/core";
// import * as moment from 'moment';

@Pipe({
  name: 'localDateTimePipeAuditoria'
})
export class LocalDateTimePipeAuditoria implements PipeTransform {
  transform(time: string): string {
    let data = new Date(time);
    let dataFormatada = data.getDate() + '/' + (data.getMonth() + 1) + '/'
    + data.getFullYear() + ' ' + data.getHours() + ':' + data.getMinutes() + ':' + data.getSeconds();
    // let dateOut: moment.Moment = moment(dataFormatada, "YYYY-MM-DD");
    return dataFormatada;
}
}



// WEBPACK FOOTER //
// /app/src/app/components/caixa/auditoria-caixa/local-date-auditoria.ts